import config from '../../utils/config';

const state = {
    //刷新主数据
    base_reload: false,
    welcome_reload: false,

    //刷新主题
    theme_key: '',

    //菜单有关
    menu_active_name: "",//激活菜单的 name 值

    //已打开的界面
    menu_opens:[],
    menu_opens_name:[],

    //
    oss_img_key:null
};

const mutations = {
    setBaseData_baseReload(state,value){
        state.base_reload = value
    },
    setBaseData_welcomeReload(state,value){
        state.welcome_reload = value
    },
    setBaseData_themeKey(state,value){
        state.theme_key = value
    },

    setBaseData_Menu(state,data){
        state.menu_active_name = data.active_name
    },

    clearBaseData_MenuOpens(state){
        state.menu_opens.splice(0, state.menu_opens.length);
        state.menu_opens_name.splice(0, state.menu_opens_name.length);
    },
    delBaseData_MenuOpens(state,index){
        state.menu_opens.splice(index, 1);
        state.menu_opens_name.splice(index, 1);
    },
    setBaseData_MenuOpens(state,data){
        state.menu_opens.filter(item => item.curr == 1).map(item => (item.curr = 0));
        var fid = data.fid;//程序ID

        var has = state.menu_opens.filter(item => item.fid == fid)[0];
        if(has){
            has['curr'] = 1;
            has['fn'] = data.fn;
            has['url'] = data.url;
        }
        else{
            if(state.menu_opens.length == config.cache_page_qty){
                state.menu_opens.splice(0,1);
                state.menu_opens_name.splice(0,1);
            }
            state.menu_opens.splice(state.menu_opens.length, 0, {
                fid: fid,//程序ID
                fn:data.fn,//程序名称
                url:data.url,//路径
                curr:1,//状态
            });
            var names = data.path.split('/');
            var name = names[1]+'-'+names[2];
            state.menu_opens_name.splice(state.menu_opens.length, 0, name);
        }
    },

    setBaseData_ossImgKey(state,data){
        state.oss_img_key = data;
    },
};

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/baseData.js